module.exports = __webpack_public_path__ + "7495c9e189dad10c5bafe28fbdb6f1ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/meredicte-2.png
// module id = 327
// module chunks = 1